import { api } from "@/helpers/apis";
import {
  SqlWarehousesResponseSchema,
  SqlWarehouseDetailSchema,
  SqlWarehouseFilterOptionsSchema,
  SqlWarehouseCostTrendsResponseSchema,
  SqlWarehouseEventsResponseSchema,
  SqlWarehouseCostResponseSchema,
  SqlWarehouseUtilizationEfficiencyResponseSchema,
  UnifiedQueriesResponseSchema,
  ResourceOpportunitiesResponseSchema,
  type SqlWarehousesResponse,
  type SqlWarehouseDetail,
  type SqlWarehouseFilterOptions,
  type SqlWarehouseCostTrendsResponse,
  type SqlWarehouseEventsResponse,
  type SqlWarehouseCostResponse,
  type SqlWarehouseUtilizationEfficiencyResponse,
  type UnifiedQueriesResponse,
  type ResourceOpportunitiesResponse,
  type SqlWarehousesParams,
  type SqlWarehouseDetailParams,
  type SqlWarehouseFilterParams,
  type SqlWarehouseCostTrendsParams,
  type SqlWarehouseEventsParams,
  type SqlWarehouseCostParams,
  type SqlWarehouseUtilizationParams,
  type UnifiedQueriesParams,
  type ResourceOpportunitiesParams,
  InitialQuestionsSchema,
  type InitialQuestionsResponse,
  type InitialQuestionsParams,
} from "./types";

const BASE_URL = "/api/v1/databricks";

// SQL Warehouses APIs
export const getSqlWarehouses = (params: SqlWarehousesParams = {}) =>
  api.get<SqlWarehousesResponse>(`${BASE_URL}/warehouses`, params, 0, SqlWarehousesResponseSchema);

export const getSqlWarehouseDetail = (params: SqlWarehouseDetailParams) =>
  api.get<SqlWarehouseDetail>(
    `${BASE_URL}/warehouses/${params.warehouse_id}`,
    {},
    0,
    SqlWarehouseDetailSchema
  );

export const getSqlWarehouseFilters = (params: SqlWarehouseFilterParams = {}) =>
  api.get<SqlWarehouseFilterOptions>(
    `${BASE_URL}/warehouses/filters`,
    params,
    0,
    SqlWarehouseFilterOptionsSchema
  );

export const getSqlWarehouseCostTrends = (params: SqlWarehouseCostTrendsParams) =>
  api.get<SqlWarehouseCostTrendsResponse>(
    `${BASE_URL}/warehouses/cost-trends`,
    params,
    0,
    SqlWarehouseCostTrendsResponseSchema
  );

export const getSqlWarehouseEvents = (warehouseId: string, params: SqlWarehouseEventsParams) =>
  api.get<SqlWarehouseEventsResponse>(
    `${BASE_URL}/warehouses/${warehouseId}/events`,
    params,
    0,
    SqlWarehouseEventsResponseSchema
  );

export const getSqlWarehouseCost = (warehouseId: string, params: SqlWarehouseCostParams) =>
  api.get<SqlWarehouseCostResponse>(
    `${BASE_URL}/warehouses/${warehouseId}/cost`,
    params,
    0,
    SqlWarehouseCostResponseSchema
  );

export const getSqlWarehouseUtilizationEfficiency = (
  warehouseId: string,
  params: SqlWarehouseUtilizationParams
) =>
  api.get<SqlWarehouseUtilizationEfficiencyResponse>(
    `${BASE_URL}/warehouses/${warehouseId}/utilization-efficiency`,
    params,
    0,
    SqlWarehouseUtilizationEfficiencyResponseSchema
  );

export const getUnifiedQueries = (params: UnifiedQueriesParams) =>
  api.get<UnifiedQueriesResponse>(
    `${BASE_URL}/queries/unified`,
    params,
    0,
    UnifiedQueriesResponseSchema
  );

export const getResourceOpportunities = (params: ResourceOpportunitiesParams) =>
  api.get<ResourceOpportunitiesResponse>(
    `${BASE_URL}/opportunities/resource`,
    params,
    0,
    ResourceOpportunitiesResponseSchema
  );

export const getInitialQuestions = (params: InitialQuestionsParams) =>
  api.get<InitialQuestionsResponse>(
    `${BASE_URL}/datapilot/initial-questions`,
    params,
    0,
    InitialQuestionsSchema
  );
